import { Badge } from "@drone-js/core";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { AdaptiveBadge } from "apps/propertySelection/automaticLists/AdaptiveBadge";
import type { FunctionComponent } from "react";

interface Props {
    publishing: boolean;
}

export const BatchPropertyBadge: FunctionComponent<Props> = ({ publishing }) => {
    const {
        cmsData: {
            complete: {
                draftText,
                underReviewText,
                thisListingIsBeingReviewedText,
                pleaseAllowAFewDaysForCompletionText,
            },
        },
    } = useStaticDataAtomValue();

    if (publishing) {
        return (
            <AdaptiveBadge
                variant="basic.notice"
                label={underReviewText}
                tooltip={{
                    title: underReviewText,
                    content: `${thisListingIsBeingReviewedText} ${pleaseAllowAFewDaysForCompletionText}`,
                }}
                data-testid="batch-property-badge-under-review"
            />
        );
    }

    return <Badge variant="basic.urgency" my="auto" label={draftText} data-testid="batch-property-badge-draft" />;
};
